// images
import blogImg1 from "../images/blog/img-1.jpg"
import blogImg2 from "../images/blog/img-2.jpg";
import blogImg3 from "../images/blog/img-3.jpg";
import blogImg4 from "../images/blog/img-4.jpg";
import blogImg5 from "../images/blog/img-5.jpg";
import blogImg6 from "../images/blog/img-6.jpg";
import blogImg7 from "../images/blog/img-7.jpg";
import blogImg8 from "../images/blog//img-4.jpg";
// import blogImg9 from "../images/blog/img-9.jpg";
// import blogImg10 from "../images/blog/img-10.jpg";

import blogSingleImg1 from "../images/blog/img-11.jpg";
import blogSingleImg2 from "../images/blog/img-12.jpg";
import blogSingleImg3 from "../images/blog/img-13.jpg";





const blogs = [
    {
        id: '1',
        title: 'WARRANTY FOR YOUR PRODUCT',
        title2: 'Express delivery is going to slow down in 2024.',
        tag: 'Surgery',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack',
        screens: blogImg8,
        description: 'We are proud of the quality of our services and provide guarantees for all our transport and logistics solutions. Our company guarantees the safety and timely delivery of your cargo, as well as full compliance of all services with the stated standards. In case of unforeseen situations, we promptly resolve all issues and provide compensation in accordance with the terms of the contract. Our goal is your complete satisfaction, and we do everything possible so that you feel confident and calm, trusting us with your cargo.',
        author: 'Anne William',
        create_at: 'Sep 03, 2024',
        blogSingleImg: blogSingleImg1,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Food and Beverages',
    },
    {
        id: '2',
        title: 'ORDER VIA SOCIAL NETWORKS',
        title2: 'Will supply chains become supply circles?',
        tag: 'Orthopedic',
        slug: 'Why-Industry-Are-A-Juicy-Target-For',
        screens: blogImg2,
        description: 'We keep up with the times and offer you a convenient way to order our services through social networks. Now you can easily and quickly place an order for delivery, storage or any other service by simply writing to us in messengers of popular social networks. Our managers will promptly respond to your requests, help you choose the best solution and provide all the necessary information. Thanks to this, you can solve all transport problems without leaving your home or office. Subscribe to our pages on social networks to stay up to date with all the news and promotions!',
        author: 'Anne William',
        create_at: 'Sep 03, 2024',
        blogSingleImg: blogSingleImg2,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Fresh Fish & Meat',
    },
    {
        id: '3',
        title: 'WARRANTY FOR YOUR PRODUCT',
        title2: 'Express delivery is going to slow down in 2024.',
        tag: 'Surgery',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack',
        screens: blogImg3,
        description: 'We are proud of the quality of our services and provide guarantees for all our transport and logistics solutions. Our company guarantees the safety and timely delivery of your cargo, as well as full compliance of all services with the stated standards. In case of unforeseen situations, we promptly resolve all issues and provide compensation in accordance with the terms of the contract. Our goal is your complete satisfaction, and we do everything possible so that you feel confident and calm, trusting us with your cargo.',
        author: 'Anne William',
        create_at: 'Sep 03, 2024',
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Food and Beverages',
    },
    {
        id: '4',
        title: 'WARRANTY FOR YOUR PRODUCT',
        title2: 'Express delivery is going to slow down in 2024.',
        tag: 'Surgery',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack',
        screens: blogImg8,
        description: 'We are proud of the quality of our services and provide guarantees for all our transport and logistics solutions. Our company guarantees the safety and timely delivery of your cargo, as well as full compliance of all services with the stated standards. In case of unforeseen situations, we promptly resolve all issues and provide compensation in accordance with the terms of the contract. Our goal is your complete satisfaction, and we do everything possible so that you feel confident and calm, trusting us with your cargo.',
        author: 'Anne William',
        create_at: 'Sep 03, 2024',

        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Food and Beverages',
    },
    {
        id: '5',
        title: 'ORDER VIA SOCIAL NETWORKS',
        title2: 'Will supply chains become supply circles?',
        tag: 'Orthopedic',
        slug: 'Why-Industry-Are-A-Juicy-Target-For',
        screens: blogImg5,
        description: 'We keep up with the times and offer you a convenient way to order our services through social networks. Now you can easily and quickly place an order for delivery, storage or any other service by simply writing to us in messengers of popular social networks. Our managers will promptly respond to your requests, help you choose the best solution and provide all the necessary information. Thanks to this, you can solve all transport problems without leaving your home or office. Subscribe to our pages on social networks to stay up to date with all the news and promotions!',
        author: 'Anne William',
        create_at: 'Sep 03, 2024',

        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Fresh Fish & Meat',
    },
    {
        id: '6',
        title: 'WARRANTY FOR YOUR PRODUCT',
        title2: 'Express delivery is going to slow down in 2024.',
        tag: 'Surgery',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack',
        screens: blogImg6,
        description: 'We are proud of the quality of our services and provide guarantees for all our transport and logistics solutions. Our company guarantees the safety and timely delivery of your cargo, as well as full compliance of all services with the stated standards. In case of unforeseen situations, we promptly resolve all issues and provide compensation in accordance with the terms of the contract. Our goal is your complete satisfaction, and we do everything possible so that you feel confident and calm, trusting us with your cargo.',
        author: 'Anne William',
        create_at: 'Sep 03, 2024',
        blogSingleImg: blogSingleImg3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Food and Beverages',
    },

    {
        id: '7',
        title: 'ORDER VIA SOCIAL NETWORKS',
        title2: 'Will supply chains become supply circles?',
        tag: 'Orthopedic',
        slug: 'Why-Industry-Are-A-Juicy-Target-For',
        screens: blogImg7,
        description: 'We keep up with the times and offer you a convenient way to order our services through social networks. Now you can easily and quickly place an order for delivery, storage or any other service by simply writing to us in messengers of popular social networks. Our managers will promptly respond to your requests, help you choose the best solution and provide all the necessary information. Thanks to this, you can solve all transport problems without leaving your home or office. Subscribe to our pages on social networks to stay up to date with all the news and promotions!',
        author: 'Anne William',
        create_at: 'Sep 03, 2024',

        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
        catagori: 'Fresh Fish & Meat',
    },





];
export default blogs;



